import { useState } from "react";

import { SavedViewsMenuLoadingRow } from "./saved-views-menu-loading-row";

interface DeleteSavedViewsProps {
  isDeleting: boolean;
  onDelete(): Promise<void>;
  cancelDelete(): void;
}

export const DeleteSavedViews = ({
  isDeleting,
  onDelete,
  cancelDelete,
}: DeleteSavedViewsProps) => {
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const deleteSavedView = async () => {
    try {
      setIsDeleteLoading(true);
      await onDelete();
    } finally {
      setIsDeleteLoading(false);
    }
  };

  if (!isDeleting) {
    return null;
  }

  return (
    <div className="text-xs w-full h-full flex items-center bg-inherit z-1">
      <SavedViewsMenuLoadingRow isLoading={isDeleteLoading} text="Deleting...">
        <div className="text-xs flex items-center">
          <button
            className="text-mars mr-3 hover:bg-v2-primary px-3 py-1 rounded"
            onClick={deleteSavedView}
          >
            YES, DELETE
          </button>
          <button
            className="text-cosmic+1 hover:bg-v2-primary px-3 py-1 rounded"
            onClick={cancelDelete}
          >
            CANCEL
          </button>
        </div>
      </SavedViewsMenuLoadingRow>
    </div>
  );
};
